export default function ContactInformation(){
    return(
        <section>ContactInformation</section>
    );
}